import styled from "styled-components";

const Span = styled.span`
  border-radius: 0px;
  background-color: #aaa;
  color: #fff !important;
  border: none;
  line-height: 35px;
  padding: 0 15px;
`;
export default Span;
